import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../utils/theme";

interface PaginatorProps {
  prevRoute: string;
  nextRoute: string;
  title: string;
}

const PaginatorContainer = styled.div`
  padding: 1rem;
  display: flex;
  background-color: ${colors.gris};
  border-radius: 10px 10px 0 0;
  margin-bottom: 2rem;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 550px) {
    flex-direction: column;
  }
`;

const Title = styled.span`
  color: ${colors.primary};
  font-size: 1.5rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 500px) {
    text-align: center;
  }
`;

const Arrow = styled.span`
  .bx {
    background-color: ${colors.blanco};
    font-size: 2rem;
    color: ${colors.primary};
    border-radius: 50%;
  }
`;

const Paginator: React.FC<PaginatorProps> = ({
  prevRoute,
  nextRoute,
  title,
}) => {
  return (
    <PaginatorContainer>
      <Arrow>
        <Link to={prevRoute}>
          <i className="bx bx-chevron-left"></i>
        </Link>
      </Arrow>

      <Title>{title}</Title>

      <Arrow>
        {nextRoute && (
          <Arrow>
            <Link to={nextRoute}>
              <i className="bx bx-chevron-right"></i>
            </Link>
          </Arrow>
        )}
      </Arrow>
    </PaginatorContainer>
  );
};

export default Paginator;
